import React, { ComponentProps, useCallback } from 'react';
import { css } from '@/styled-system/css';
import { getPayloadFromToken } from 'zdocs-web-core/lib/token';
import {
  IFrameErrorTypes,
  ZDocsEditor,
  ZDocsEditorError,
} from '@zillow/zdocs-web';
import { Header } from './Header';

const Container = (props: ComponentProps<'div'>) => (
  <div
    className={css({
      height: '100%',
      '& > #embedded-doc-editor': {
        margin: 0,
        padding: 0,
        outline: 'none',
        zDocsLg: {
          height: `calc(100% - 4rem)`,
        },
      },
    })}
    {...props}
  />
);
export interface StandaloneEditorProps {
  token: string;
  onError: () => void;
}

export default function StandaloneEditor({
  token,
  onError,
}: StandaloneEditorProps) {
  const payload = getPayloadFromToken(token);
  const name = payload?.zdocs?.name ?? '';
  const standaloneEditorPort = '3003';
  const url =
    window.location.port === standaloneEditorPort
      ? window.location.href.replace(standaloneEditorPort, '3000')
      : window.location.href;
  const iFrameSrc = url.replace(/\/editor(\/[^?#]*)?/, '/embed/editor');
  const handleEditorError = useCallback(
    (message: ZDocsEditorError) => {
      const { error } = message;

      const isErrorRecoverable =
        error === IFrameErrorTypes.PageImageError ||
        error === IFrameErrorTypes.SaveError;

      if (!isErrorRecoverable) {
        onError();
      }
    },
    [onError]
  );

  return (
    <Container>
      <Header name={name} />
      <ZDocsEditor
        title="zDocs - document editor"
        id="embedded-doc-editor"
        data-cy="embedded-doc-editor"
        url={iFrameSrc}
        onError={onError}
        onEditorError={handleEditorError}
      />
    </Container>
  );
}
